import shop from './API/shop'
import group from './API/group'
import entry from './API/entry'
import follow from './API/follow'
export const API = {shop,group,entry,follow} as const;
